import React, { FC, RefObject, useRef } from 'react';

interface Props {
  videoRef: RefObject<HTMLVideoElement>;
}

export const FeedbackVideoPanel: FC<Props> = ({ videoRef }) => {
  const retriedWithoutCorsRef = useRef(false);

  // One-shot fallback: if the CORS-mode load fails (an origin without
  // Access-Control-Allow-Origin), retry in no-cors mode — playback matters
  // more than the shared cache, and thumbnails degrade gracefully on their own.
  const handleError = () => {
    const el = videoRef.current;
    if (!el || retriedWithoutCorsRef.current || !el.crossOrigin) return;
    retriedWithoutCorsRef.current = true;
    const src = el.currentSrc || el.src;
    el.removeAttribute('crossorigin');
    el.src = src;
    el.load();
  };

  return (
    // Review deliverables ship without caption tracks.
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      ref={videoRef}
      className="h-[485px] w-[920px] bg-black rounded-2xl"
      preload='metadata'
      controls
      controlsList="nodownload"
      onError={handleError}
      // same CORS mode as the thumbnail extractor so both share one HTTP
      // cache entry instead of downloading the video twice
      crossOrigin="anonymous"
    />
  );
};
